import { render, staticRenderFns } from "./MyMessages.vue?vue&type=template&id=ed33109c&"
import script from "./MyMessages.vue?vue&type=script&lang=js&"
export * from "./MyMessages.vue?vue&type=script&lang=js&"
import style0 from "./MyMessages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports